<template>
  <div v-show="dIsShow">
    <div class="dialog-mask" v-show="mMask" @click="close"></div>
    <div class="dialog">
      <div class="title">{{ message.name }}</div>
      <div class="close" @click="close"></div>
      <div class="message">
        <div class="name">{{ message.respon }}</div>
        <div class="infos">
          <div class="line" v-for="item in message.infos" :key="item.line">{{ item.detail }}</div>
        </div>

        <div class="name">{{ message.qualify }}</div>
        <div class="infos">
          <div class="line" v-for="item in message.must" :key="item.line">{{ item.detail }}</div>
        </div>

        <div class="name">招聘岗位：</div>
        <div class="infos">
          <div class="line">{{ message.number }}</div>
        </div>

        <div class="name">工作地点：</div>
        <div class="infos">
          <div class="line">{{ message.addrs }}</div>
        </div>
      </div>
      <div class="btgroup">
        <button @click="close()">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    dIsShow: Boolean,
    message: Object
  },
  data() {
    return {
      mMask: true
    };
  },
  mounted() {},
  model: {
    prop: "dIsShow,message",
    event: "closeModel"
  },
  methods: {
    close() {
      this.$emit("closeModel", false);
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
}
.dialog {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 100001;
  width: 60%;
  padding: 60px;
  color: #333;
  background-color: #fff;
  overflow: hidden;
  border-radius: 5px;

  .title {
    margin-bottom: 30px;
    text-align: center;
    font-size: 40px;
  }
  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 9;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background: red;
  }
  .message {
    color: #999;
    font-size: 16px;
    line-height: 26px;
    padding: 25px;
    .name {
      margin-bottom: 10px;
      font-size: 20px;
      color: #666;
      line-height: 30px;
    }
    .infos {
      margin-bottom: 30px;
    }
  }
  .btgroup {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      font-size: 16px;
      padding: 10px 15px;
      margin-left: 15px;
      line-height: 1;
      border: 1px solid #eee;
      background-color: #fff;
      cursor: pointer;
    }
  }
}
</style>
